import _objectSpread from "D:\\project\\vaultstagingstripe\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import { defineIntegration, convertIntegrationFnToClass } from '@sentry/core';
import { WINDOW } from '../helpers.js';
var INTEGRATION_NAME = 'HttpContext';
var _httpContextIntegration = function _httpContextIntegration() {
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent: function preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      var url = event.request && event.request.url || WINDOW.location && WINDOW.location.href;
      var _ref = WINDOW.document || {},
        referrer = _ref.referrer;
      var _ref2 = WINDOW.navigator || {},
        userAgent = _ref2.userAgent;
      var headers = _objectSpread(_objectSpread(_objectSpread({}, event.request && event.request.headers), referrer && {
        Referer: referrer
      }), userAgent && {
        'User-Agent': userAgent
      });
      var request = _objectSpread(_objectSpread(_objectSpread({}, event.request), url && {
        url: url
      }), {}, {
        headers: headers
      });
      event.request = request;
    }
  };
};
var httpContextIntegration = defineIntegration(_httpContextIntegration);

/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
var HttpContext = convertIntegrationFnToClass(INTEGRATION_NAME, httpContextIntegration);
export { HttpContext, httpContextIntegration };